/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';
import {TemplateCosoFattoreQualificanteDTO} from '../model/TemplateCosoFattoreQualificanteDTO';

/**
* TemplateService service.
* @module api/TemplateServiceApi
* @version v0
*/
export class TemplateServiceApi {

    /**
    * Constructs a new TemplateServiceApi. 
    * @alias module:api/TemplateServiceApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getTemplateMonitor operation.
     * @callback moduleapi/TemplateServiceApi~getTemplateMonitorCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TemplateCosoFattoreQualificanteDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the monitor containing all the template qualitative questions
     * Request to get all the template qualitative questions in a format to fill the template monitor page.
     * @param {module:api/TemplateServiceApi~getTemplateMonitorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getTemplateMonitor(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [TemplateCosoFattoreQualificanteDTO];

      return this.apiClient.callApi(
        '/api/template/monitor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateTemplate operation.
     * @callback moduleapi/TemplateServiceApi~updateTemplateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the coso framework
     * Update the template qualitative question association with the control functions and the operational scopes
     * @param {Array.<module:model/TemplateCosoFattoreQualificanteDTO>} body 
     * @param {module:api/TemplateServiceApi~updateTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateTemplate(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateTemplate");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/template/updateTemplate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}